import React, { useEffect, useState } from 'react';
import { TitleAndSubTitleBlockProps } from './Types';
import CustomHeader from '../CustomHeader';
import CustomSubTitle from '../CustomSubTitle';

const TitleAndSubTitleBlock = ({
  title,
  subtitle,
  backgroundImage,
  gradientOverlay,
  subTitleStyle,
  titleLevel = 'h2',
  titleTextColor = '#fff',
  titleTextAlignment = 'left',
}: TitleAndSubTitleBlockProps) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const gradientOverlayStyle =
    'linear-gradient(179deg, rgba(0, 85, 128, 0.24) 1.62%, rgba(5, 50, 77, 0.70) 30.28%, rgba(7, 30, 49, 0.75) 99%)';

  const baseStyle = {
    ...(isMobile && { paddingLeft: '26px' }),
  };

  const divStyle = {
    ...baseStyle,
    ...(backgroundImage && {
      backgroundImage: gradientOverlay
        ? `${gradientOverlayStyle}, url(${backgroundImage})`
        : `url(${backgroundImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
    }),
  };

  return (
    <div
      className={`text-left w-full h-full flex flex-col ${!isMobile ? 'justify-center' : 'pt-12'}`}
      style={divStyle}
    >
      <CustomHeader
        text={title}
        data-testid="mock-styled-header"
        headerStyle={{
          level: titleLevel,
          color: titleTextColor,
          alignment: titleTextAlignment,
          fontWeight: 600,
          fontSize: isMobile ? '28px' : '64px',
          lineHeight: isMobile ? '44px' : '80px',
          letterSpacing: '0%',
          paddingTop: isMobile ? '32px' : '100px',
          fontFamily: 'Source Sans 3',
          className: 'benefit-title',
        }}
      />
      <CustomSubTitle
        subtitle={subtitle}
        subTitleStyle={{
          color: '#FFF',
          fontFamily: 'Source Sans Pro',
          fontSize: isMobile ? '19px' : '58px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: isMobile ? '32px' : '58px',
          marginTop: '1.5rem',
          marginBottom: isMobile ? '1rem' : undefined,
          ...(subTitleStyle || {}),
        }}
      />
    </div>
  );
};

export default TitleAndSubTitleBlock;
